export const renderAntDMessageConfig = (content: string) => ({
  style: {
    marginTop: 70,
  },
  content,
  duration: 5,
});
